import { tsValidate, tsValidateArray, tsValidateBoolean, tsValidateOptionalId, tsValidateOptionalObject, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { findingViewSectionType_ByOrder, findingViewSectionType_FishBone, findingViewSectionType_Flat, findingViewSectionType_Graph, } from './types.js';
import { Validator_FindingRenderMethod } from '../finding-render-method/validation.js';
import { Validator_FindingSortMethod } from '../finding-sort-method/validation.js';
import { Validator_Fishbone } from '../fishbone/validation.js';
const Validator_FindingViewSection_Base = {
    label: tsValidateString(),
    config: {
        showChiefComplaints: tsValidateBoolean(false),
        showOnlyChiefComplaints: tsValidateBoolean(false),
        showFindingInfoTooltip: tsValidateBoolean(false),
        renderPrevFindings: tsValidateBoolean(false),
        spanPanelWidth: tsValidateBoolean(false),
        fillPanelHeight: tsValidateBoolean(false),
        alwaysVisible: tsValidateBoolean(false),
        allowFindingEdit: tsValidateBoolean(false),
        showAttributes: tsValidateBoolean(false),
        specialAttention_Disease: tsValidateBoolean(false),
        forceShowNegative: tsValidateBoolean(false),
        explicitYes: tsValidateBoolean(false),
        showDate: tsValidateBoolean(false),
    }
};
const Validator_FindingViewSection_Flat = {
    ...Validator_FindingViewSection_Base,
    type: tsValidateValue([findingViewSectionType_Flat]),
    data: {
        contextRuleId: tsValidateUniqueId,
        findingRenderMethod: Validator_FindingRenderMethod,
        findingSortMethod: Validator_FindingSortMethod,
    }
};
const Validator_FindingViewSection_ByOrder = {
    ...Validator_FindingViewSection_Base,
    type: tsValidateValue([findingViewSectionType_ByOrder]),
    data: {
        contextRuleId: tsValidateUniqueId,
        orderContextRuleId: tsValidateOptionalId,
        findingRenderMethod: Validator_FindingRenderMethod,
        findingSortMethod: Validator_FindingSortMethod,
    }
};
const Validator_FindingViewSection_FishBone = {
    ...Validator_FindingViewSection_Base,
    type: tsValidateValue([findingViewSectionType_FishBone]),
    data: {
        fishbone: tsValidateOptionalObject(Validator_Fishbone),
    }
};
const Validator_FindingViewSection_Graph = {
    ...Validator_FindingViewSection_Base,
    type: tsValidateValue([findingViewSectionType_Graph]),
    data: {
        variableIds: tsValidateArray(tsValidateUniqueId),
        abbreviation: tsValidateString(undefined, false),
        alert: tsValidateOptionalObject({
            variableId: tsValidateUniqueId,
            normalValueId: tsValidateOptionalId,
        })
    }
};
export const Validator_FindingViewSection = (section) => {
    if (!section)
        return 'Validator did not get a section';
    switch (section.type) {
        case findingViewSectionType_Flat:
            return tsValidate(section, Validator_FindingViewSection_Flat);
        case findingViewSectionType_ByOrder:
            return tsValidate(section, Validator_FindingViewSection_ByOrder);
        case findingViewSectionType_FishBone:
            return tsValidate(section, Validator_FindingViewSection_FishBone);
        case findingViewSectionType_Graph:
            return tsValidate(section, Validator_FindingViewSection_Graph);
        default:
            // @ts-ignore
            return `Missing validator for section of type ${section.type}`;
    }
};
//# sourceMappingURL=validation.js.map